import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';
import axios from 'axios';

import {API_URL} from '../../common/configs/index';
import FlashMessage from '../components/FlashMessage';
import PrivacyPolicy from '../components/PrivacyPolicy';

class Conditions extends Component {
  constructor(props) {
    super(props);

    this.accept = this.accept.bind(this);
    this.decline = this.decline.bind(this);
    this.consent_id = props.location.query.consent_id;
    this.project_id = props.location.query.projectId;
    this.state = {
      isLoading: false,
      isAccepted: true,
      showFooter: true,
      error: null
    };
  }

  // eslint-disable-next-line class-methods-use-this
  componentDidMount() {
    if (window.self === window.top) {
      document.body.className = 'terms-bg';
    }
  }

  request(isAccepted) {
    const {
      location: {query},
      intl
    } = this.props;
    const params = {
      token: query.token,
      projectId: this.project_id,
      is_accepted: JSON.stringify(isAccepted)
    };
    if (this.consent_id) params.consent_id = this.consent_id;
    this.setState({isLoading: true, isAccepted, error: null});

    axios
      .put(`${API_URL}social/consent`, params)
      .then(response => {
        this.setState({isLoading: false, showFooter: false});
        if (typeof window !== 'undefined') {
          window.top.location.href = response.data.url;
        }
      })
      .catch(error => {
        let errorMsg = error.message;
        if (error.response) {
          const {code} = error.response.data.error;
          if (intl.messages[`http.${code}`]) {
            errorMsg = intl.messages[`http.${code}`];
          }
        }
        this.setState({
          isLoading: false,
          error: errorMsg
        });
      });
  }

  accept() {
    this.request(true);
  }

  decline() {
    this.request(false);
  }

  render() {
    const {intl} = this.props;
    const {isLoading, isAccepted, error, showFooter} = this.state;

    return (
      <div className="terms-page">
        {error && <FlashMessage type="error" message={error} />}
        <PrivacyPolicy />
        {showFooter && (
          <div className="terms-page__footer">
            <div className="terms-page__footer__inner">
              <button
                id="accept_conditions"
                onClick={this.accept}
                disabled={isLoading}
                className="form-button terms-page__button terms-page__button--accept"
              >
                {intl.messages[`${isLoading && isAccepted ? 'form.loading' : 'btn.accept'}`]}
              </button>
              <button
                id="decline_conditions"
                onClick={this.decline}
                disabled={isLoading}
                className="form-button button-outline terms-page__button terms-page__button--decline"
              >
                {intl.messages[`${isLoading && !isAccepted ? 'form.loading' : 'btn.decline'}`]}
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

Conditions.propTypes = {
  location: PropTypes.object.isRequired,
  intl: PropTypes.object
};

export default injectIntl(Conditions);



// WEBPACK FOOTER //
// ./pages/Conditions.jsx